// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RJ_a"};